import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Users, Target } from 'lucide-react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="page-container">
        {/* Header */}
        <header className="page-header">
          <Link to="/" className="back-button">
            <span>Back to Home</span>
          </Link>
          <h1 className="page-title">About COVA</h1>
          <p className="page-subtitle">Learning Resource Management System</p>
        </header>

        {/* Content */}
        <div className="about-content">
          <div className="about-section">
            <div className="section-icon">
              <BookOpen size={48} />
            </div>
            <div className="section-content">
              <h2>What is COVA?</h2>
              <p>
                A learning resource management system for Computer Science students 
                designed to organize and provide easy access to study materials, 
                lecture notes, and past examination papers.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="section-icon">
              <Target size={48} />
            </div>
            <div className="section-content">
              <h2>Why it exists</h2>
              <p>
                To organize lecture notes and past papers in a structured system 
                that makes learning materials easily accessible and well-organized 
                for Computer Science students.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="section-icon">
              <Users size={48} />
            </div>
            <div className="section-content">
              <h2>Who built it</h2>
              <p>
                Built by Cliff as a comprehensive solution for managing 
                Computer Science Year 1 learning resources.
              </p>
            </div>
          </div>

          <div className="about-footer">
            <div className="version-info">
              <h3>Version Information</h3>
              <p>COVA Learning Resources v2.0</p>
              <p>Modern File Explorer System</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
